import styles from './loading-spinner.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import classNames from 'clsx';
import { IconBase } from '../../node_modules/react-icons/lib/iconBase.js';

const DsxLoadingSpinner = props => {
  const className = classNames(props.className, styles['spinner']);
  return /*#__PURE__*/jsx(IconBase, {
    viewBox: "0 0 50 50",
    ...props,
    className: className,
    children: /*#__PURE__*/jsx("circle", {
      className: styles['path'],
      style: {
        stroke: props.style?.color
      },
      cx: "25",
      cy: "25",
      r: "20",
      fill: "none",
      strokeWidth: "5"
    })
  });
};

export { DsxLoadingSpinner };
